import { useEffect, useState } from 'react'
import axios from 'axios'
import { StatisticsWidget5 } from '../../../_metronic/partials/widgets'
import { toast } from "react-toastify";
import { formatPrice } from '../../../_metronic/helpers/utils';
import { useAuth } from '../auth';
import { ClubCashInfoTable }  from './table/ClubCashInfoTable';
import { KTCard, useDebounce } from '../../../_metronic/helpers'
import dayjs from 'dayjs';


const Index = () => {
    const { haveAccess, currentUser } = useAuth()
    const [data, setData] = useState()
    const [clubCashData, setClubCashData] = useState({})
    const [isLoading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(50)
    const [page, setPage] = useState(1)
    const [searchType, setSearchType] = useState('trucker_id')
    const [search, setSearch] = useState('')
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)

    const getClubCashStats = () => {
        axios
        .get(`${process.env.REACT_APP_API_V3_URL}/wallets/club-cash/stats`)
        .then((response) => {
            if (response?.data && response?.data?.length) {
                setData(response?.data[0])
            }
        })
        .catch((err) => {
            if (err && err.response && err.response?.data && err.response?.data?.message) {
                toast.error(err.response.data.message);
            } else {
                toast.error("Technical Error, Please Try Again");
            }
        });
    }

    useEffect(() => {
        getClubCashStats()
    }, [])

    const getClubCashTable = () => {
    setLoading(true)
    axios
      .get(`${process.env.REACT_APP_API_V3_URL}/wallets/club-cash`, {
        params: {
          page_size: pageSize,
          page,
          sort: 4,
          ...(searchType !== 'date' ? { [searchType]: debouncedSearchTerm?.trim() || '' } : {}),
          ...(startDate ? { start_date: dayjs(startDate).format('YYYY-MM-DD') } : ''),
          ...(endDate ? { end_date: dayjs(endDate).format('YYYY-MM-DD') } : '')
        },
      })
        .then((response) => {
        setClubCashData(response.data)
        setLoading(false)
    }).catch((err) => {
        setLoading(false)
        if (err && err.response && err.response?.data && err.response?.data?.message) {
            toast.error(err.response.data.message);
        } else {
            toast.error("Technical Error, Please Try Again");
        }
    })
}

const debouncedSearchTerm = useDebounce(search, 700);

useEffect(() => {
      if (debouncedSearchTerm !== undefined && search !== undefined) {
      getClubCashTable()
    }
}, [page, pageSize, debouncedSearchTerm, startDate, endDate])

 useEffect(() => {
    if ((search && debouncedSearchTerm) || startDate || endDate) {
      setPage(1);
    }
    if (pageSize !== 50) {
      setPage(1);
    }
  }, [debouncedSearchTerm, pageSize, startDate, endDate]);

    return (
        <>
            {haveAccess(currentUser, 'club_cash_tranx') ?
                <div className='row g-5 g-xl-2 mb-5'>
                    <div className='col-xl-4'>
                        <StatisticsWidget5
                            className='card-xl-stretch mb-xl-8'
                            svgIcon='wallet'
                            color='main'
                            iconColor='white'
                            title={data?.total_cash_earned ? formatPrice(data?.total_cash_earned) : '$0'}
                            titleColor='white'
                            description='Total Club Cash Earned'
                            descriptionColor='white'
                        />
                    </div>

                    <div className='col-xl-4'>
                    <StatisticsWidget5
                            className='card-xl-stretch mb-xl-8'
                            svgIcon='dollar'
                            color='dark'
                            iconColor='white'
                            title={data?.cash_earned_with_booking ? formatPrice(data?.cash_earned_with_booking) : '$0'}
                            titleColor='white'
                            description='Club Cash Earned From Bookings'
                            descriptionColor='white'
                        />
                    </div>
                    <div className='col-xl-4'>
                        <StatisticsWidget5
                            className='card-xl-stretch mb-xl-8'
                            svgIcon='profile-user'
                            color='primary'
                            iconColor='white'
                            title={data?.unique_users ? data?.unique_users : '0'}
                            titleColor='white'
                            description='Users who have earned Club Cash'
                            descriptionColor='white'
                        />
                    </div>
                </div>
                :
                <div className='d-flex text-center w-100 align-content-center justify-content-center' style={{ height: '70vh', alignItems: 'center', fontSize: '42px', color: '#ffa049', background: 'rgba(0,0,0,0.1)' }}>
                    You do not have permission to view widgets
                </div>
            }
            {(haveAccess(currentUser, 'club_cash_tranx')) ?
            <KTCard>
                <ClubCashInfoTable
                    clubCashData={clubCashData}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    page={page}
                    setPage={setPage}
                    search={search}
                    setSearch={setSearch}
                    searchType={searchType}
                    setSearchType={setSearchType}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    isLoading={isLoading}
                    setLoading={setLoading}
                />
            </KTCard>
            :
            <div className='d-flex text-center w-100 align-content-center justify-content-center' style={{ height: '70vh', alignItems: 'center', fontSize: '42px', color: '#ffa049', background: 'rgba(0,0,0,0.1)' }}>
                You do not have permission to view Club Cash table
            </div>
        }
        </>
    )
}

export default Index